import { createContext, useContext, useEffect, useMemo, useRef, useState } from 'react'
import { useVariables } from '../../../../providers/VariableProvider'

export const FilterSelectorContext = createContext({
  options: [],
  selectedOption: null,
  setSelectedOption: () => {},
  applyTo: 'accountManagementOverrides',
  variableValue: [],
  selectedValues: [],
  setSelectedValues: () => {},
  showDetails: false,
  setShowDetails: () => {},
  anchorRef: { current: null },
  // New configuration options
  maxShow: 2,
  selectedText: 'Selected: ',
  moreText: 'items selected',
  hasMultipleOptions: true
})

export const useFilterSelectContext = () => {
  return useContext(FilterSelectorContext)
}

export const useFilterSelectorValues = ({
  options,
  applyTo,
  defaultSelected,
  maxShow = 2,
  selectedText = 'Selected: ',
  moreText = 'items selected'
}) => {
  const { setVariable, getVariable } = useVariables()
  const [selectedOption, setSelectedOption] = useState(defaultSelected || options?.[0]?.value || null)
  const [variableValue, setVariableValue] = useState([])
  const [selectedValues, setSelectedValues] = useState([])
  const [showDetails, setShowDetails] = useState(false)
  const anchorRef = useRef(null)

  // Check if there's only one option
  const hasMultipleOptions = useMemo(() => {
    return options && options.length > 1
  }, [options])

  useEffect(() => {
    if (!getVariable(applyTo)) {
      setVariable(applyTo, [])
    }
  }, [applyTo, getVariable, setVariable])

  useEffect(() => {
    if (variableValue !== getVariable(applyTo) && !showDetails) {
      setVariable(applyTo, variableValue || [])
    }
  }, [applyTo, variableValue, setVariable, getVariable, showDetails])

  return useMemo(() => ({
    options,
    selectedOption,
    setSelectedOption,
    applyTo,
    variableValue,
    setVariableValue,
    selectedValues,
    setSelectedValues,
    showDetails,
    setShowDetails,
    anchorRef,
    maxShow,
    selectedText,
    moreText,
    hasMultipleOptions
  }), [options, selectedOption, applyTo, variableValue, selectedValues, showDetails, maxShow, selectedText, moreText, hasMultipleOptions])
}
